import { ReactNode } from 'react';

import { tokens, Typography, Stack } from '@cast/design-system';

type MetadataFieldProps = {
  label: string;
  children: ReactNode;
  withDivider?: boolean;
  testId?: string;
};

export const MetadataField = ({
  label,
  children,
  withDivider,
  testId,
}: MetadataFieldProps) => (
  <Stack
    gap={2}
    px={12}
    minWidth={0}
    data-testid={testId}
    sx={
      withDivider
        ? {
            borderLeft: '1px solid',
            borderColor: tokens.theme.border.structural.neutral,
          }
        : undefined
    }
  >
    <Typography
      variant="L12R"
      sx={{ color: tokens.theme.fg.structural.secondary }}
    >
      {label}
    </Typography>
    {children}
  </Stack>
);
